import { Action } from '@zaibot/fsa';

export default Action<{buttonNo: number; origin: number; buttonAction?: string; lasttoucheditem?: any}>('UPDATE_BUTTON_NO');

export const buttonNoSelection: number = 0; 
export const buttonNotitiesenFavorieten: number = 21;
export const buttonNotitiesToevoegen: number = 1; // Notities toevoegen
export const buttonFavourietToevoegen: number = 2; // Favouriet toevoegen
export const buttonMijnItems: number = 3; // Mijn Items
export const buttonVragenlijstRelatie: number = 5; // Vragenlijst
export const buttonDeelnemersVragenlijst: number = 6; 
export const buttonNotitiesVragenlijst: number = 25; 
export const buttonUitloggen: number = 7; // Uitloggen
export const buttonBekijkItems: number = 8; // Bekijk Items
export const buttonNotitiesToevoegenFlyover: number = 9; // Note area
export const buttonNotitiesEditenText: number = 10; 
export const buttonNotitiesEditenCategories: number = 11; 
export const buttonNotitiesEditenDeelnemers: number = 12; 
export const buttonNotitiesSelectieDeelnemers: number = 13;
export const buttonNotitiesDeSelectieDeelnemers: number = 14;
export const buttonLogout: number = 15;
export const buttonLogin: number = 16;
export const buttonMijnBoekwerk: number = 17;
export const buttonMijnBoekwerkCloseButton: number = 18;
export const buttonMijnBoekwerkAddRemove: number = 20;
export const buttonDropDownCategory: number =21;
export const buttonDropDownSorting: number =22;
export const buttonAdminNotitiesButton: number=23;
export const buttonMenuButton: number=24;
export const buttonUsergroupEditenDeelnemers: number = 25; 
export const buttonUsergroupSelectieDeelnemers: number = 26;
export const buttonUsergroupDeSelectieDeelnemers: number = 27;
export const buttonUsergroupCreeerDeelnemers: number = 28;

export const itemButtonMinNumber: number = 100;

export const itemButtonTypeActionBewerkenItem: string = 'BI'; // Bewerken item
export const itemButtonTypeActionDeleteItem: string = 'DI'; // Delete item
export const itemButtonTypeActionBewerkenCategory: string = 'BC'; // Bewerken Category
export const itemButtonTypeActionDeleteCategory: string = 'DC'; // Delete Category
export const itemButtonTypeActionBewerkenBookmark: string = 'BB'; // Bewerken Bookmark
export const itemButtonTypeActionBewerkenQuestion: string = 'BQ'; // Bewerken item
export const itemButtonTypeActionDeleteQuestion: string = 'DQ'; // Delete item
export const itemButtonTypeActionBewerkenUsergroup: string = 'BU'; // Bewerken usergroup
export const noItemButton: string = ''; // No Itembutton

export const originUndefined = 0;
export const originNoteMenu = 1;
export const originFlyover = 2;
export const originAdmin = 3;

/* tslint:disable no-magic-numbers */
export function GetDelay(buttonNo: number) {
    switch(buttonNo) {
        case buttonMenuButton:
        // case buttonAdminNotitiesButton:       
          return 300;
        default:
          if (itemButtonMinNumber>=itemButtonMinNumber) {
            return 500;
          }
          return 0;
      }
}
/* tslint:enable */



// WEBPACK FOOTER //
// (webpack)-remove-block-loader??ref--5-0!./src/focuslock/actions/UPDATE_BUTTON_NO.tsx